module.exports = __webpack_public_path__ + "img/Group-32705-1-1.67d9ff9d.png";